import {AccordionItem, TabsComponent} from '@/components/molecules'
import {LABELS} from '@/utils/constants/commonConstants'
import {
  SubItemDataTable,
  FulfillmentContent,
  AdjustmentsContent,
  TaxesInformationContent,
  ItemDiscountContent,
} from '@/containers'

const {ORDER_ITEM_OVERVIEW_PAGE} = LABELS || {}

export const SubItemAccordionContent = ({subItemAccordionData}) => {
  return (
    <AccordionItem
      label={ORDER_ITEM_OVERVIEW_PAGE.SubItems}
      isDark={true}
      content={<SubItemDataTable subItemAccordionData={subItemAccordionData} />}
    />
  )
}

export const TransactionDetailsAccordionContent = ({transactionDetailsData}) => {
  const {fulfillmentData, adjustmentsData, taxesInformationData} = transactionDetailsData || {}

  const tabList = [
    {
      id: 'fulfillment',
      tabLabel: 'Fulfillment',
      tabComponent: <FulfillmentContent fulfillmentData={fulfillmentData} />,
    },
    {
      id: 'adjustments',
      tabLabel: 'Adjustments',
      tabComponent: <AdjustmentsContent adjustmentsData={adjustmentsData} />,
    },
    {
      id: 'taxesInformation',
      tabLabel: 'Taxes Information',
      tabComponent: <TaxesInformationContent taxesInformationData={taxesInformationData} />,
    },
  ]

  return (
    <AccordionItem
      label={ORDER_ITEM_OVERVIEW_PAGE.TransactionDetails}
      isDark={true}
      content={
        <div>
          <TabsComponent tabList={tabList} defaultTabIndex={0} />
        </div>
      }
    />
  )
}

export const DiscountInformationAccordionContent = ({discountInfoList}) => {
  let tabList = []
  discountInfoList?.forEach((item, i) => {
    const tabObj = {
      id: 'itemDiscount_' + i,
      tabLabel: 'Item Discount ' + (i + 1),
      tabComponent: <ItemDiscountContent itemDiscountData={item} key={i} />,
    }
    tabList.push(tabObj)
  })

  return (
    <AccordionItem
      label={ORDER_ITEM_OVERVIEW_PAGE.DiscountInformation}
      isDark={true}
      content={
        <div>
          <TabsComponent tabList={tabList} defaultTabIndex={0} />
        </div>
      }
    />
  )
}
